import { apiPaths } from '@core/http/apiPaths';
import { httpClient } from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { SurveyDetailsCloneRequestModel, SurveyDetailsModel } from '@models/Surveys';

export const getSurveyDetails = createAsyncThunk(`${EntityReducers.surveys}/getDetails`, async (id: string) => {
  const response: AxiosResponse<SurveyDetailsModel> = await httpClient.get(
    apiPaths.surveys.surveyDetails({ surveyId: id })
  );

  return response.data;
});

interface CreateSurveyCloneAsyncThunk extends SurveyDetailsCloneRequestModel {}

export const createSurveyClone = createAsyncThunk(
  `${EntityReducers.surveys}/createClone`,
  async (payload: CreateSurveyCloneAsyncThunk) => {
    const response: AxiosResponse = await httpClient.post(apiPaths.surveys.createClone, payload);

    return response.data;
  }
);

export const thunks = {
  getSurveyDetails,
  createSurveyClone,
};
